import { useEffect, useState } from 'react';
import { facebookConfig } from '../../commons/config';

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: facebook.FacebookStatic;
  }
}

export const useFacebookSdk = () => {
  const [sdkLoaded, setSdkLoaded] = useState(false);
  const { appId } = facebookConfig;
  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        version: 'v18.0',
      });
      setSdkLoaded(true);
      logger.info('Facebook SDK initialized');
    };
    if (window.FB) {
      window.fbAsyncInit();
    }
  }, [appId]);
  return { sdkLoaded };
};
